module.exports = __webpack_public_path__ + "img/book(10).462a5cd4.png";